'use strict';

/**
 * @classname Fade
 * @classdesc KVスライダー
 */
export default class Fade {
	/**
	 * @constructor
	 * @param {jQuery} $e - .kv-slide
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		const slidePattern = $e.data('slide-pattern') || null;
		let options = {
			loop: true,
			effect: 'fade',
			speed: 1500,
			autoplay: {
				delay: 3500
			}
		}
		console.log(options);
		const swiper = new Swiper('.kv-slide', options);
	};
};
